import * as yup from 'yup';

const validators = (__) => () => {
    return (
        yup.object({
            startDate: yup.string().required(__(`form.startDate.error`)),
            endDate: yup.string().required(__(`form.endDate.error`))
        })
    )
}

export default validators
